"use strict";

/******
VIDEO
*******/
function openVideo(event) {
  var modal = document.getElementById('js-modal-video'),
      iframe = modal.querySelector('iframe'),
      src = 'https://www.youtube.com/embed/' + event.srcElement.dataset.id + '?autoplay=1&enablejsapi=1';
  iframe.src = src;
  modal.classList.add('is-open');
}